<div class="fw-bold mb-2">{{ 'Gespeicherte Suchformulare' | translate }}</div>
<div class="d-flex align-items-center gap-2">
  <dx-select-box class="flex-fill"
                 [dataSource]="allSearchForms"
                 displayExpr="name"
                 [(value)]="selectedSearchForm"
                 [showClearButton]="true"
                 placeholder="{{ 'Suchformular auswählen...' | translate }}"
                 (onValueChanged)="onSearchFormSelectionChanged()"
  >
    <div *dxTemplate="let item of 'item'">
      <span>{{ item.name }}</span>
      <span *ngIf="item.indexState && item.indexState !== 'ready_for_usage'"
            class="text-muted ms-2 small fst-italic">({{ 'Suchindex wird aufgebaut' | translate }})</span>
    </div>
  </dx-select-box>
  <dx-button *ngIf="loginService.currentUser.currentClaim == 'MANAGER' || loginService.currentUser.currentClaim == 'ADMIN'"
             icon="edit"
             type="default"
             stylingMode="text"
             hint="{{ 'Suchformular editieren / anlegen' | translate }}"
             (onClick)="editSearchForm()">
  </dx-button>
</div>

<div *ngIf="selectedSearchForm?.searchOptions?.length" class="mt-3">
  <ng-container *ngFor="let row of selectedSearchForm.searchOptions; let i = index">
    <div class="mb-2">
      <div class="fw-bold mb-1">
        <span *ngIf="i > 0" class="fst-italic text-primary">{{ selectedSearchForm.filterCondition | translate }} </span>
        {{ getFieldDisplayText(row) }}
        <span *ngIf="row.operator" class="text-muted fw-normal fst-italic"> {{ row.operator | translate }}</span>
      </div>

      <ng-container *ngIf="!isNoValue(row)">

        <dx-tag-box *ngIf="isMultiValue(row)"
                    valueChangeEvent="input"
                    [items]="getDropdownValues(i)"
                    [(value)]="row.values"
                    (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                    [acceptCustomValue]="true"
                    [showClearButton]="true"
                    [searchEnabled]="true"
                    placeholder="{{ 'Werte eingeben...' | translate }}"
                    (onCustomItemCreating)="$event.customItem = $event.text">
        </dx-tag-box>

        <ng-container *ngIf="!isMultiValue(row) && isRange(row)">
          <div *ngIf="getDataType(row) === 'number'" class="d-flex align-items-center gap-2">
            <dx-number-box [(value)]="row.value"
                           valueChangeEvent="input"
                           (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                           placeholder="{{ 'Von' | translate }}"
                           style="flex: 1;">
            </dx-number-box>
            <span class="text-muted">–</span>
            <dx-number-box [(value)]="row.valueTo"
                           valueChangeEvent="input"
                           (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                           placeholder="{{ 'Bis' | translate }}"
                           style="flex: 1;">
            </dx-number-box>
          </div>
          <div *ngIf="getDataType(row) === 'date'" class="d-flex align-items-center gap-2">
            <dx-date-box [(value)]="row.value"
                         valueChangeEvent="input"
                         (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                         type="date"
                         displayFormat="dd.MM.yyyy"
                         placeholder="{{ 'Von' | translate }}"
                         style="flex: 1;">
            </dx-date-box>
            <span class="text-muted">–</span>
            <dx-date-box [(value)]="row.valueTo"
                         valueChangeEvent="input"
                         (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                         type="date"
                         displayFormat="dd.MM.yyyy"
                         placeholder="{{ 'Bis' | translate }}"
                         style="flex: 1;">
            </dx-date-box>
          </div>
        </ng-container>

        <ng-container *ngIf="!isMultiValue(row) && !isRange(row)" [ngSwitch]="getDataType(row)">

          <ng-container *ngSwitchCase="'string'">
            <dx-select-box *ngIf="getDropdownValues(i).length; else stringFallback"
                           [(value)]="row.value"
                           [items]="getDropdownValues(i)"
                           [acceptCustomValue]="true"
                           [searchEnabled]="true"
                           [showClearButton]="true"
                           valueChangeEvent="input"
                           (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                           placeholder="{{ 'Wert auswählen...' | translate }}">
            </dx-select-box>
            <ng-template #stringFallback>
              <dx-text-box [(value)]="row.value"
                           valueChangeEvent="input"
                           (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"                           
                           placeholder="{{ 'Wert eingeben...' | translate }}">
              </dx-text-box>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'number'">
            <dx-select-box *ngIf="getDropdownValues(i).length; else numberFallback"
                           [(value)]="row.value"
                           [items]="getDropdownValues(i)"
                           [acceptCustomValue]="true"
                           [searchEnabled]="true"
                           [showClearButton]="true"
                           valueChangeEvent="input"
                           (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                           placeholder="{{ 'Wert auswählen...' | translate }}">
            </dx-select-box>
            <ng-template #numberFallback>
              <dx-number-box [(value)]="row.value"
                             valueChangeEvent="input"
                             (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                             placeholder="{{ 'Wert eingeben...' | translate }}">
              </dx-number-box>
            </ng-template>
          </ng-container>

          <dx-date-box *ngSwitchCase="'date'"
                       [(value)]="row.value"
                       valueChangeEvent="input"
                       (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                       type="date"
                       displayFormat="dd.MM.yyyy"
                       placeholder="{{ 'Datum wählen...' | translate }}">
          </dx-date-box>

          <dx-tag-box *ngSwitchCase="'multiEnum'"
                      [items]="row.values"
                      [(value)]="row.values"
                      valueChangeEvent="input"
                      (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                      [showSelectionControls]="true"
                      [showClearButton]="true"
                      [acceptCustomValue]="true"
                      (onInput)="onTriggerAutomaticSearchTimeout($event)"
                      placeholder="{{ 'Werte auswählen...' | translate }}">
          </dx-tag-box>

          <dx-select-box *ngSwitchCase="'enum'"
                         [(value)]="row.value"
                         valueChangeEvent="input"
                         (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                         [items]="[]"
                         [acceptCustomValue]="true"
                         placeholder="{{ 'Wert auswählen...' | translate }}">
          </dx-select-box>

          <dx-text-box *ngSwitchDefault
                       [(value)]="row.value"
                       valueChangeEvent="input"
                       (onValueChanged)="onTriggerAutomaticSearchAfterTimeout()"
                       placeholder="{{ 'Wert eingeben...' | translate }}">
          </dx-text-box>

        </ng-container>

      </ng-container>
    </div>
  </ng-container>
</div>
